import React from "react";
import PropTypes from "prop-types";

const TicketDescription = ({ query }) => {
  return (
    <div className="card mt-2">
      <div className="card-body">
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-2" style={{ fontWeight: "bold" }}>
                <label htmlFor="ticketDescription">Ticket Description:</label>
              </div>
              <div className="col-md-10">
                <div style={{ cursor: "pointer" }}>
                  <div>{query}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TicketDescription.propTypes = {
  query: PropTypes.string,
};

export default TicketDescription;
